import { Base } from '@studiometa/js-toolkit';

/**
 * MenuPush component.
 *
 * On mouseenter of any [data-ref="MenuPush.links[]"] inside the component,
 * crossfades [data-ref="MenuPush.images[]"] (two stacked images) to the new src.
 *
 */
export default class MenuPush extends Base {
  static config = {
    name: 'MenuPush',
    refs: ['links[]', 'images[]'],
    options: {
      defaultSrc: String,
    },
  };

  _front = 0;

  /**
   * Mounted.
   */
  mounted() {
    this._currentSrc = this.$options.defaultSrc;
  }

  /**
   * @param {{ index: number }} options
   */
  onLinksMouseenter({ index }) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    const src = this.$refs.links[index]?.dataset.pushImage || this.$options.defaultSrc;
    this._setImage(src);
  }

  /**
   * Reset to default image when leaving the component.
   */
  onMouseleave() {
    this._setImage(this.$options.defaultSrc);
  }

  /**
   * Load new src in the back image, crossfade when ready.
   * @param {string} src
   */
  _setImage(src) {
    const images = this.$refs.images;
    if (!src || !images?.length || src === this._currentSrc) return;
    this._currentSrc = src;

    const front = images[this._front];
    const back = images[this._front ^ 1];

    if (this._swapHandler) {
      back.removeEventListener('load', this._swapHandler);
    }

    back.removeAttribute('srcset');
    back.src = src;

    const swap = () => {
      back.removeEventListener('load', swap);
      back.style.opacity = '1';
      front.style.opacity = '0';
      this._front ^= 1;
    };

    this._swapHandler = swap;

    if (back.complete && back.naturalWidth > 0) {
      swap();
    } else {
      back.addEventListener('load', swap, { once: true });
    }
  }
}
